import { Component } from '@angular/core';

@Component({
  selector: 'mobile-layout',
  templateUrl: './mobile-layout.component.html',
  styleUrls: []
})
export class MobileLayoutComponent {
}
